/**
 * Tipos de evento para citas (alineados con config/cita_tipos.php del backend).
 */
export const DEFAULT_TIPO_CITA = 'CONSULTA'

export const TIPO_CITA_OPTIONS = [
  { value: 'CONSULTA', label: 'Consulta' },
  { value: 'CONTROL', label: 'Cita para control médico' },
  { value: 'CIRUGIA', label: 'Cirugía' },
  { value: 'URGENCIA', label: 'Urgencia' },
  { value: 'VACUNACION', label: 'Vacuna' },
  { value: 'CUMPLEANOS', label: 'Cumpleaños' },
  { value: 'PIPETA', label: 'Pipeta' },
  { value: 'DESPARASITACION', label: 'Desparasitación' },
  { value: 'BANO', label: 'Baño' },
  { value: 'MEDICAMENTO', label: 'Medicamento' },
  { value: 'PESO', label: 'Registro de peso' },
  { value: 'OTRO', label: 'Otro' },
]

export const LABELS_TIPO_CITA = Object.fromEntries(
  TIPO_CITA_OPTIONS.map((o) => [o.value, o.label])
)

/** Variante visual del Badge por código */
export const TIPO_CITA_BADGE_VARIANT = {
  CONSULTA: 'info',
  CONTROL: 'success',
  CIRUGIA: 'danger',
  URGENCIA: 'warning',
  VACUNACION: 'purple',
  CUMPLEANOS: 'purple',
  PIPETA: 'info',
  DESPARASITACION: 'success',
  BANO: 'info',
  MEDICAMENTO: 'warning',
  PESO: 'default',
  OTRO: 'default',
}

/** Tipos que requieren clínica (alineado con config/cita_tipos.php backend). */
export const TIPO_CITA_REQUIRE_CLINICA = new Set([
  'CONSULTA',
  'CONTROL',
  'CIRUGIA',
  'URGENCIA',
  'VACUNACION',
])

export function getTipoCitaLabel(codigo) {
  if (!codigo) return 'Consulta'
  return LABELS_TIPO_CITA[codigo] || codigo
}

export function isTipoCitaClinicaRequired(codigo) {
  return TIPO_CITA_REQUIRE_CLINICA.has(codigo)
}
